import React, { useState } from "react";
import { Container, Row } from "reactstrap";

//Import Section Title
import SectionTitle from "../common/section-title";
import ServiceBox from "./services-box";

const Process = ({ sectionClass }) => {
  const [state] = useState({
    services1: [
      {
        icon: "pe-7s-attention",
        title: "Issue Tracking",
        desc:
          "Easily collect bug reports and identify problems sooner rather than later",
      },
      {
        icon: "pe-7s-plugin",
        title: "Feature Requests",
        desc:
          "Allow your customers to tell you exactly what they want from your product.",
      },
      {
        icon: "pe-7s-photo",
        title: "File Uploads",
        desc:
          "Users can upload photos or videos to better communicate information",
      },
    ],
    services2: [
      {
        icon: "pe-7s-map-2",
        title: "Public Roadmap",
        desc:
          "Share your product roadmap with customers via a customizable kanban board with voting, filtering, and status tracking",
      },
      {
        icon: "pe-7s-shield",
        title: "AI Spam Detection",
        desc:
          "Automatically detect and filter AI-generated spam with behavioral and text analysis scoring",
      },
      {
        icon: "pe-7s-news-paper",
        title: "Changelog",
        desc:
          "Announce shipped features and link them to resolved feedback to close the loop with users",
      },
    ],
    services3: [
      {
        icon: "pe-7s-copy-file",
        title: "Duplicate Detection",
        desc:
          "Smart suggestions surface similar existing posts during submission to reduce duplicates and consolidate feedback",
      },
      {
        icon: "pe-7s-tools",
        title: "SDK & API",
        desc:
          "Full-featured SDKs in 7+ languages — JavaScript, Python, Go, C#, PHP, Ruby, and Java",
      },
      {
        icon: "pe-7s-cloud-upload",
        title: "Integrations",
        desc:
          "Seamlessly export tickets to JIRA, Trello, and Asana to keep your development workflow in sync",
      },
    ],
  });

  return (
    <React.Fragment>
      <section className={"section " + sectionClass} id="services">
        <Container>
          {/* section title */}
          <SectionTitle
            title="Our Services"
            desc="More than a bug tracker — Public Backlog is a complete feedback platform. Collect issues and feature requests, share your roadmap, announce shipped features, and integrate with the tools you already use. AI-powered spam detection and duplicate suggestions keep your boards clean and actionable."
          />

          <Row className="mt-4">
            {/* services box */}
            <ServiceBox services={state.services1} />
          </Row>

          <Row className="mt-4">
            {/* service box */}
            <ServiceBox services={state.services2} />
          </Row>

          <Row className="mt-4">
            {/* service box */}
            <ServiceBox services={state.services3} />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Process;
